import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { ShoppingBag, Minus, Plus, X } from "lucide-react";

export default function Panier() {
  const { lines, updateQuantity, removeLine, totalCents } = useCart();
  const [buying, setBuying] = useState(false);

  const checkout = async () => {
    setBuying(true);
    try {
      const items = lines.map((l) => ({ product_id: l.product_id, size: l.size, quantity: l.quantity }));
      const { data } = await api.post("/shop/checkout", { items });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de l'initialisation du paiement");
      setBuying(false);
    }
  };

  if (lines.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-5 pt-16 pb-16 text-center">
        <ShoppingBag size={40} className="mx-auto mb-4 text-white/20" />
        <h1 className="font-display font-bold text-xl mb-3">Ton panier est vide</h1>
        <Link to="/" className="btn-solid inline-flex !py-3 !px-6">Voir la boutique</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-5 pt-10 pb-16">
      <h1 className="font-display font-black text-3xl tracking-tight mb-8">Mon panier</h1>

      <div className="space-y-3 mb-8">
        {lines.map((l) => (
          <div key={`${l.product_id}-${l.size}`} className="card-glass p-4 flex items-center gap-4">
            {l.image ? <img src={l.image} alt="" className="w-16 h-16 rounded-lg object-cover shrink-0" /> : <div className="w-16 h-16 rounded-lg bg-white/5 shrink-0" />}
            <div className="flex-1 min-w-0">
              <h3 className="font-display font-bold text-sm truncate">{l.name}</h3>
              {l.size && <p className="text-xs text-white/40">Taille {l.size}</p>}
              <p className="text-[#00F0FF] font-bold text-sm mt-1">{(l.price_cents / 100).toFixed(2)}€</p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button onClick={() => updateQuantity(l.product_id, l.size, l.quantity - 1)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10"><Minus size={12} /></button>
              <span className="font-display font-bold w-5 text-center text-sm">{l.quantity}</span>
              <button onClick={() => updateQuantity(l.product_id, l.size, l.quantity + 1)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10"><Plus size={12} /></button>
            </div>
            <button onClick={() => removeLine(l.product_id, l.size)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/50 hover:text-[#FF0033] shrink-0"><X size={14} /></button>
          </div>
        ))}
      </div>

      <div className="card-glass p-5 flex items-center justify-between mb-6">
        <span className="font-display font-bold">Total</span>
        <span className="font-display font-black text-xl text-[#00F0FF]">{(totalCents / 100).toFixed(2)}€</span>
      </div>

      <button onClick={checkout} disabled={buying} className="btn-neon w-full !py-3 disabled:opacity-50">
        {buying ? "..." : "Passer au paiement"}
      </button>
      <p className="text-[10px] text-white/30 text-center mt-3">
        Paiement sécurisé par Stripe. <a href="https://lafribue.fr/cgv" className="hover:text-white transition">Conditions générales de vente</a>.
      </p>
    </div>
  );
}
